import { BaseUseCase } from "../../../../useCases/UseCaseBase";
class SearchSymbolUseCase extends BaseUseCase {
    constructor(marginRepo) {
        super();
        this.marginRepo = marginRepo;
    }
    async fetchResult(req) {
        return await this.marginRepo.getSearchedSymbolData(req);
    }
}
export default SearchSymbolUseCase;
